import api from './api';
import { VehicleType } from '../types';

export const vehicleTypesService = {
  getAll: async (isActive?: boolean): Promise<VehicleType[]> => {
    const params = isActive !== undefined ? { isActive } : {};
    const response = await api.get('/vehicle-types', { params });
    return response.data;
  },

  getById: async (id: string): Promise<VehicleType> => {
    const response = await api.get(`/vehicle-types/${id}`);
    return response.data;
  },

  create: async (data: Partial<VehicleType>): Promise<VehicleType> => {
    const response = await api.post('/vehicle-types', data);
    return response.data;
  },

  update: async (id: string, data: Partial<VehicleType>): Promise<VehicleType> => {
    const response = await api.patch(`/vehicle-types/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/vehicle-types/${id}`);
  },
};
